/* =====================================================================
   DEMO / MOCK DATA — NOT PRODUCTION
   ---------------------------------------------------------------------
   Placeholder Bella Vita categories & services with INVENTED names,
   durations and prices. Ported from design-v2/js/booking-demo.js purely
   as fixtures for frontend development.

   This is NOT the Bella Vita catalogue and NOT Bella Vita pricing.
   The real catalogue/prices/durations come from Odoo via the API adapter.
   Do NOT copy any of this into the Odoo production database.
   ===================================================================== */

export const CATEGORIES = [
  { id: 'hair-style', name: { ar: 'قص وتصفيف', en: 'Cut & Styling' } },
  { id: 'hair-care',  name: { ar: 'عناية الشعر', en: 'Hair Care' } },
  { id: 'color',      name: { ar: 'صبغات', en: 'Colour' } },
  { id: 'face',       name: { ar: 'الوجه والحواجب', en: 'Face & Brows' } },
  { id: 'nails',      name: { ar: 'الأظافر', en: 'Nails' } },
  { id: 'spa',        name: { ar: 'استرخاء', en: 'Spa' } },
  { id: 'makeup',     name: { ar: 'مكياج', en: 'Makeup' } },
];

const IMG = (f) => `/assets/img/${f}.jpg`;

export const SERVICES = [
  { id: 's1',  cat: 'hair-style', name: { ar: 'قص شعر وتصفيف', en: 'Haircut & style' }, price: 140, dur: 45, img: IMG('bv-portrait-veil') },
  { id: 's2',  cat: 'hair-style', name: { ar: 'استشوار وتموّج', en: 'Blow-dry & waves' }, price: 120, dur: 40, img: IMG('bv-editorial-water') },
  { id: 's3',  cat: 'hair-style', name: { ar: 'تسريحة مناسبات', en: 'Occasion updo' }, price: 260, dur: 60, img: IMG('bv-lifestyle-marble') },
  { id: 's4',  cat: 'hair-care',  name: { ar: 'حمّام زيت مغذٍّ', en: 'Nourishing oil bath' }, price: 110, dur: 35, img: IMG('bv-tex-sage') },
  { id: 's5',  cat: 'hair-care',  name: { ar: 'علاج بروتين', en: 'Protein treatment' }, price: 520, dur: 90, img: IMG('bv-tex-gold') },
  { id: 's6',  cat: 'color',      name: { ar: 'صبغة جذور', en: 'Root colour' }, price: 180, dur: 60, img: IMG('bv-tex-petals') },
  { id: 's7',  cat: 'color',      name: { ar: 'هايلايت / أومبريه', en: 'Highlights / ombré' }, price: 640, dur: 120, img: IMG('bv-skincare-line') },
  { id: 's8',  cat: 'face',       name: { ar: 'تنظيف بشرة عميق', en: 'Deep facial' }, price: 210, dur: 50, img: IMG('bv-portrait-veil') },
  { id: 's9',  cat: 'face',       name: { ar: 'تنظيف وتحديد حواجب', en: 'Brow shape & tint' }, price: 70, dur: 20, img: IMG('bv-editorial-water') },
  { id: 's10', cat: 'nails',      name: { ar: 'منيكير كلاسيك', en: 'Classic manicure' }, price: 95, dur: 40, img: IMG('bv-tex-pink') },
  { id: 's11', cat: 'nails',      name: { ar: 'بديكير سبا', en: 'Spa pedicure' }, price: 110, dur: 45, img: IMG('bv-lifestyle-marble') },
  { id: 's12', cat: 'spa',        name: { ar: 'مساج استرخائي (٦٠ د)', en: 'Relax massage (60m)' }, price: 230, dur: 60, img: IMG('bv-tex-forest') },
  { id: 's13', cat: 'spa',        name: { ar: 'حمّام مغربي', en: 'Moroccan bath' }, price: 320, dur: 75, img: IMG('bv-tex-sage') },
  { id: 's14', cat: 'makeup',     name: { ar: 'مكياج سهرة', en: 'Evening makeup' }, price: 300, dur: 60, img: IMG('bv-portrait-veil') },
  { id: 's15', cat: 'makeup',     name: { ar: 'مكياج عروس', en: 'Bridal makeup' }, price: 950, dur: 120, img: IMG('bv-skincare-line') },
];

/* Illustrative only — the prototype does not compute authoritative tax. */
export const TAX = { vatRate: 0.15, depositRate: 1 };
